/** Reach landing page media (CloudFront) */
export const REACH_MEDIA_CDN =
  "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive";

export const REACH_WHY_HIRE = `${REACH_MEDIA_CDN}/why-hire.png`;
export const REACH_WHY_PROJECTS = `${REACH_MEDIA_CDN}/why-projects.png`;
export const REACH_WHY_INTERVIEWS = `${REACH_MEDIA_CDN}/why-interviews.png`;
export const REACH_WHY_PLACEMENT = `${REACH_MEDIA_CDN}/why-placement.png`;
export const REACH_HERO_UNDERLINE = `${REACH_MEDIA_CDN}/hero-underline.svg`;
export const REACH_CARD_DIVIDER = `${REACH_MEDIA_CDN}/card-divider.svg`;
